import { render, staticRenderFns } from "./mainModal.vue?vue&type=template&id=554b90af&"
import script from "./mainModal.vue?vue&type=script&lang=js&"
export * from "./mainModal.vue?vue&type=script&lang=js&"
import style0 from "./mainModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports